<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>Remerciements</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 0.93em;">À MON</span> club des cinq bien-aimées – Penn, Tamm, Lea et Jenn. Nous avons été ensemble contre vents et marées et les pénuries de Pringles. Je ne peux imaginer meilleur cadeau de la Vie que vous toutes.</p>
<p class="P_Normal">Et à mes autres sœurs, que j’aime assez pour envisager (une minute) d’abandonner le café – Lisa, Ree, Ren et Mary.</p>
<p class="P_Normal">Merci comme toujours à Dreamspinner – Elizabeth, Lynn, Liz et son équipe, Naomi (que j’appâte avec des cookies et du thé), et tous les autres qui prennent ce que mon cerveau vomit, gèrent mon chaos et emballent ma folie.</p>
<p class="P_Normal">Et, enfin, à tous ceux et celles qui pensent un peu bizarrement et voient le monde avec des couleurs différentes, ne laissez personne vous interdire de porter ces talons. Soyez vous-mêmes. Soyez gentils. Aimez bien. Et soyez aimés.</p>
<p class="P_Normal__And__Left_Alignment__And__Left_Indent__And__Tabs"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?3fab6453